import { gql } from '@apollo/client';

export const PROVINCES = gql`
  query getAvailableProvinces($inputCountry: Country, $inputProvince: String!, $inputRegions: [String!]) {
    getAvailableProvinces(inputCountry: $inputCountry, inputProvince: $inputProvince, inputRegions: $inputRegions)
  }
`;
